enum QuestionType {
    Checkbox = 'Checkbox',
    Date = 'Date',
    DropDown = 'DropDown',
    MultipleChoice = 'MultipleChoice',
    ParagraphText = 'ParagraphText',
    SingleLineText = 'SingleLineText',
}

export default QuestionType;
